import { render, staticRenderFns } from "./V3Banner.vue?vue&type=template&id=82e06b00"
import script from "./V3Banner.vue?vue&type=script&lang=ts"
export * from "./V3Banner.vue?vue&type=script&lang=ts"
import style0 from "./V3Banner.vue?vue&type=style&index=0&id=82e06b00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports